var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEHub2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.1891 5H48.654C52.1597 5 55.0003 7.86463 55.0003 11.3999V19.9363C55.0003 23.4716 52.1597 26.3362 48.654 26.3362H40.1891C36.6834 26.3362 33.8428 23.4716 33.8428 19.9363V11.3999C33.8428 7.86463 36.6834 5 40.1891 5Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8112 33.6638C23.3169 33.6638 26.1575 36.5284 26.1575 40.0637V48.6001C26.1575 52.133 23.3169 55 19.8112 55H11.3463C7.84064 55 5 52.133 5 48.6001V40.0637C5 36.5284 7.84064 33.6638 11.3463 33.6638H19.8112ZM48.6537 33.6638C52.1594 33.6638 55 36.5284 55 40.0637V48.6001C55 52.133 52.1594 55 48.6537 55H40.1888C36.6831 55 33.8425 52.133 33.8425 48.6001V40.0637C33.8425 36.5284 36.6831 33.6638 40.1888 33.6638H48.6537ZM19.8112 5C23.3169 5 26.1575 7.86463 26.1575 11.3999V19.9363C26.1575 23.4716 23.3169 26.3362 19.8112 26.3362H11.3463C7.84064 26.3362 5 23.4716 5 19.9363V11.3999C5 7.86463 7.84064 5 11.3463 5H19.8112Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEHub2);
export default __webpack_public_path__ + "static/media/e-hub2.81e08da92b7c6b0fc6ba1c8f872d7c1a.svg";
export { ForwardRef as ReactComponent };